export const Permissions = {
  Host: {
    Project: {
      Create: 'Host.Project.Create',
      Update: 'Host.Project.Update',
      Delete: 'Host.Project.Delete',
      Decommission: 'Host.Project.Decommission',
    },
    Tenant: {
      Manage: 'Host.Tenant.Manage',
      Settings: {
        Manage: 'Host.Tenant.Settings.Manage',
      },
    },
    User: {
      Manage: 'Host.User.Manage',
      AssignRole: 'Host.User.AssignRole',
      Settings: {
        ManageClaudeToken: 'Host.User.Settings.ManageClaudeToken',
      },
    },
    SandboxImage: {
      List: 'Host.SandboxImage.List',
    },
  },
  Project: {
    Read: 'Project.Read',
    Settings: {
      Manage: 'Project.Settings.Manage',
    },
    Analytics: {
      Read: 'Project.Analytics.Read',
    },
    WorkItem: {
      Create: 'Project.WorkItem.Create',
      Read: 'Project.WorkItem.Read',
      Update: 'Project.WorkItem.Update',
      Delete: 'Project.WorkItem.Delete',
      Complete: 'Project.WorkItem.Complete',
    },
    Context: {
      Create: 'Project.Context.Create',
      Read: 'Project.Context.Read',
      Update: 'Project.Context.Update',
      Delete: 'Project.Context.Delete',
    },
    Connectors: {
      Read: 'Project.Connectors.Read',
      Manage: 'Project.Connectors.Manage',
    },
    Feeds: {
      Read: 'Project.Feeds.Read',
      Manage: 'Project.Feeds.Manage',
    },
    VariableGroups: {
      Read: 'Project.VariableGroups.Read',
      Manage: 'Project.VariableGroups.Manage',
    },
    Prompt: {
      Create: 'Project.Prompt.Create',
      Read: 'Project.Prompt.Read',
      Update: 'Project.Prompt.Update',
      Delete: 'Project.Prompt.Delete',
    },
    Agent: {
      Create: 'Project.Agent.Create',
      Read: 'Project.Agent.Read',
      Update: 'Project.Agent.Update',
      Delete: 'Project.Agent.Delete',
    },
    Skill: {
      Create: 'Project.Skill.Create',
      Read: 'Project.Skill.Read',
      Update: 'Project.Skill.Update',
      Delete: 'Project.Skill.Delete',
    },
    Intent: {
      Create: 'Project.Intent.Create',
      Read: 'Project.Intent.Read',
      Update: 'Project.Intent.Update',
      Delete: 'Project.Intent.Delete',
    },
    Chat: {
      Create: 'Project.Chat.Create',
      Read: 'Project.Chat.Read',
      Update: 'Project.Chat.Update',
      Delete: 'Project.Chat.Delete',
    },
    TestPlan: {
      Create: 'Project.TestPlan.Create',
      Read: 'Project.TestPlan.Read',
      Update: 'Project.TestPlan.Update',
      Delete: 'Project.TestPlan.Delete',
      Push: 'Project.TestPlan.Push',
    },
    TestSuite: {
      Create: 'Project.TestSuite.Create',
      Read: 'Project.TestSuite.Read',
      Update: 'Project.TestSuite.Update',
      Delete: 'Project.TestSuite.Delete',
      Push: 'Project.TestSuite.Push',
    },
    TestCase: {
      Read: 'Project.TestCase.Read',
      Update: 'Project.TestCase.Update',
      Delete: 'Project.TestCase.Delete',
      Push: 'Project.TestCase.Push',
    },
    Workflow: {
      View: 'Project.Workflow.View',
      Create: 'Project.Workflow.Create',
      Edit: 'Project.Workflow.Edit',
      Delete: 'Project.Workflow.Delete',
      Trigger: 'Project.Workflow.Trigger',
      Approve: 'Project.Workflow.Approve',
      Intervene: 'Project.Workflow.Intervene',
      Cancel: 'Project.Workflow.Cancel',
      Admin: 'Project.Workflow.Admin',
    },
    Chain: {
      View: 'Project.Chain.View',
      Create: 'Project.Chain.Create',
      Edit: 'Project.Chain.Edit',
      Delete: 'Project.Chain.Delete',
      Start: 'Project.Chain.Start',
    },
    Schedule: {
      View: 'Project.Schedule.View',
      Create: 'Project.Schedule.Create',
      Edit: 'Project.Schedule.Edit',
      Delete: 'Project.Schedule.Delete',
    },
  },
} as const

export const RoleNames = {
  Admin: 'Admin',
  Developer: 'Developer',
  QualityAssurance: 'Quality Assurance',
  ProductOwner: 'Product Owner',
  Guest: 'Guest',
} as const

export const PromptPhaseNames = {
  Analysis: 'Analysis',
  Implementation: 'Implementation',
  Testing: 'Testing',
  Documentation: 'Documentation',
} as const

const promptPhaseEditableRoles: Record<string, readonly string[]> = {
  [PromptPhaseNames.Analysis]: [RoleNames.Admin, RoleNames.Developer, RoleNames.QualityAssurance, RoleNames.ProductOwner],
  [PromptPhaseNames.Implementation]: [RoleNames.Admin, RoleNames.Developer],
  [PromptPhaseNames.Testing]: [RoleNames.Admin, RoleNames.QualityAssurance],
  [PromptPhaseNames.Documentation]: [RoleNames.Admin, RoleNames.Developer, RoleNames.ProductOwner, RoleNames.QualityAssurance],
}

export const canEditPromptPhase = (phaseName: string | undefined, userRoles: readonly string[]): boolean => {
  if (!phaseName) return false
  if (userRoles.includes(RoleNames.Admin)) return true
  const allowed = promptPhaseEditableRoles[phaseName]
  if (!allowed) return false
  return userRoles.some(role => allowed.includes(role))
}

export const getEditablePromptPhases = (userRoles: readonly string[]): string[] => {
  if (userRoles.includes(RoleNames.Admin)) return Object.values(PromptPhaseNames)
  return Object.values(PromptPhaseNames).filter(phase =>
    promptPhaseEditableRoles[phase].some(role => userRoles.includes(role))
  )
}
